import React, { useEffect, useState } from "react";
import { Image } from "react-bootstrap";
import api from "../../Environment";
import styles from './LandingPage.module.css';

const MostWatch = (props) => {
    return (
        <section className={`${styles.landingContainer} ${styles.watch}`}>
            <div className={styles.landingSectionTitle}>
                MOST WATCHED <br />
                <span className={styles.colorText}>THIS WEEK</span>
            </div>

            <div className={styles.watchGrid}>
                {props.topPostVideos.map((list, i) => (
                    <Image key={i}
                        src={list.preview_pic && list.preview_pic != null && list.preview_pic != ""
                            ? api.serviceUrl() + "/" + list.preview_pic
                            : "/assets/images/upload-profile-img.svg"}
                        alt={list.title}
                    />
                ))}
            </div>
        </section>
    );
};

export default MostWatch;